export interface SalesTableColumns {
  showStock: boolean
  showFee: boolean
  showPaymentMethod: boolean
}

export type SalesTableColumnId =
  | 'ticket'
  | 'lot'
  | 'gender'
  | 'type'
  | 'quantity'
  | 'stock'
  | 'unitValue'
  | 'fee'
  | 'paymentMethod'
  | 'total'

export type ColumnAlign = 'left' | 'center' | 'right'

interface ColumnDefinition {
  id: SalesTableColumnId
  track: string
  minWidth: number
  align: ColumnAlign
}

const COLUMNS: ColumnDefinition[] = [
  { id: 'ticket', track: 'minmax(200px, 2fr)', minWidth: 200, align: 'left' },
  { id: 'lot', track: 'minmax(190px, 1fr)', minWidth: 190, align: 'left' },
  { id: 'gender', track: '100px', minWidth: 100, align: 'left' },
  { id: 'type', track: 'minmax(96px, 1fr)', minWidth: 96, align: 'center' },
  { id: 'quantity', track: '67px', minWidth: 67, align: 'center' },
  { id: 'stock', track: 'minmax(80px, 1fr)', minWidth: 80, align: 'center' },
  { id: 'unitValue', track: 'minmax(104px, 1fr)', minWidth: 104, align: 'left' },
  { id: 'fee', track: 'minmax(104px, 1fr)', minWidth: 104, align: 'left' },
  { id: 'paymentMethod', track: 'minmax(150px, 1fr)', minWidth: 150, align: 'left' },
  { id: 'total', track: '141px', minWidth: 141, align: 'left' },
]

export const visibleColumns = (columns: SalesTableColumns): ColumnDefinition[] =>
  COLUMNS.filter(
    (column) =>
      (column.id !== 'stock' || columns.showStock) &&
      (column.id !== 'fee' || columns.showFee) &&
      (column.id !== 'paymentMethod' || columns.showPaymentMethod)
  )

export const gridTemplate = (columns: SalesTableColumns): string =>
  visibleColumns(columns)
    .map((column) => column.track)
    .join(' ')

export const printGridTemplate = (columns: SalesTableColumns): string =>
  visibleColumns(columns)
    .map((column) => `minmax(0, ${column.minWidth}fr)`)
    .join(' ')

export const tableMinWidth = (columns: SalesTableColumns): number =>
  visibleColumns(columns).reduce((total, column) => total + column.minWidth, 0)

export const gridLine = (columns: SalesTableColumns, id: SalesTableColumnId): number =>
  visibleColumns(columns).findIndex((column) => column.id === id) + 1
